//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'V',
  data: function data() {
    return {
      tableData: []
    };
  },
  methods: {
    open: function open() {},
    close: function close() {}
  }
};